import common from 'data/translations/de/de-AT/common.json';
import faqs from 'data/translations/de/de-AT/faqs.json';

export const translationAt = {
    ...common,
    ...faqs,
};
